/** @format */

const template = `
<label class="control control-checkbox sis-checkbox" ng-class="{'disabled': disable}"
  >{{label|translate}}
  <input name="{{name}}" type="checkbox" ng-model="ngModel" ng-change="ngChange()" ng-required="required" ng-disabled="disable" />
  <div class="control-indicator" ng-class="{invalid: form[name].$invalid}"></div>
</label>
`;
export default template;
